import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { BsLaptop, BsClock, BsPeople, BsGraphUp } from "react-icons/bs";
import LumenNavbar from "../../layout/LumenNavbar";
import LumenButton from "../../ui/LumenButton";
import NewFooter from "../../layout/NewFooter";
import "./NewHomePage.css";
import { s3_url } from "common/constants";

const NewHomePage: React.FC = () => {
  return (
    <>
      <LumenNavbar />
      <div className="lumen-home">
        <div className="top-circles" aria-hidden="true">
          <div className="top-circle top-circle-1" />
          <div className="top-circle top-circle-2" />
          <div className="top-circle top-circle-3" />
        </div>

        <section className="hero-section">
          <Container className="h-100">
            <Row className="h-100 align-items-center g-3 g-lg-0">
              <Col
                lg={6}
                className="order-2 order-lg-1 text-center text-lg-start mb-4 mb-lg-0"
              >
                <img
                  src={`${s3_url}/homepage/lumen-kauc.webp`}
                  alt="Lumen maskota na kauču"
                  className="hero-mascot"
                  loading="lazy"
                />
              </Col>
              <Col lg={6} className="order-1 order-lg-2 text-end text-lg-start">
                <div className="hero-heading">
                  <h1 className="hero-title line-1">
                    TVOJ <span className="accent">SAVEZNIK</span>
                  </h1>

                  <div className="hero-line-2">
                    <h1 className="hero-title line-2">U UČENJU</h1>
                    <p className="hero-subline mb-5">Uvijek pri ruci!</p>
                  </div>
                  <LumenButton
                    to="/poduke/rezervacija"
                    size="lg"
                    className="d-none d-md-inline mt-5"
                  >
                    REZERVIRAJ TERMIN
                  </LumenButton>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="intro-section mt-5">
          <Container>
            <Row className="justify-content-center">
              <Col lg={8}>
                <h2 className="section-title">
                  Poduke i pripreme za državnu maturu krojene za tvoj uspjeh
                </h2>
              </Col>
              <Col lg={8}>
                <p className="lead-text text-center">
                  Lumen@home nudi sveobuhvatne pripreme za maturu koje pomažu
                  učenicima da se temeljito pripreme za ispite i postignu
                  najbolje rezultate. Također, pružamo individualne poduke iz
                  raznih školskih predmeta, prilagođene potrebama svakog
                  učenika.
                </p>
                <div className="text-center mt-5">
                  <LumenButton
                    to="/poduke/rezervacija"
                    size="lg"
                    className="d-md-none hero-cta-mobile"
                  >
                    REZERVIRAJ TERMIN
                  </LumenButton>
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="double-card-section mt-5">
          <Container>
            <div className="double-card mb-5">
              <h1 className="text-center">Poduke i pripreme</h1>
              <Row className="g-4 align-items-stretch">
                <Col md={6}>
                  <div className="double-card-item">
                    <div className="dc-image">
                      <img
                        src={`${s3_url}/homepage/1.webp`}
                        alt="Pripreme"
                        loading="lazy"
                      />
                    </div>
                    <div className="dc-body">
                      <p className="dc-text dc-text-lg">
                        Poduke u manjim grupama ili individualno, uz pristup
                        prilagođen stvarnim potrebama učenika – za bolje
                        razumijevanje i samopouzdanje u učenju.
                      </p>
                      <div className="dc-cta">
                        <LumenButton
                          to="/poduke"
                          variant="outline-white"
                          size="sm"
                          className="mt-5"
                        >
                          PODUKE
                        </LumenButton>
                      </div>
                    </div>
                  </div>
                </Col>

                <Col md={6}>
                  <div className="double-card-item">
                    <div className="dc-image">
                      <img
                        src={`${s3_url}/homepage/2.webp`}
                        alt="Poduke"
                        loading="lazy"
                      />
                    </div>
                    <div className="dc-body">
                      <p className="dc-text dc-text-lg">
                        Stručno vođene instrukcije uz konkretna objašnjenja i
                        fokus na ono što ti najviše treba – bilo da nadoknađuješ
                        ili želiš dodatno učiti.
                      </p>
                      <div className="dc-cta">
                        <LumenButton
                          to="/pripreme-za-maturu"
                          variant="outline-white"
                          size="sm"
                          className="mt-5"
                        >
                          PRIPREME
                        </LumenButton>
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>

              <img
                src={`${s3_url}/homepage/knjige.webp`}
                alt="Stog knjiga"
                className="double-card-books d-none d-md-block"
                loading="lazy"
              />
            </div>
          </Container>
        </section>

        <section className="features-section mt-5">
          <Container>
            <h3 className="section-title features-title">
              Zašto odabrati Lumen@Home?
            </h3>

            <div className="features-grid d-none d-lg-grid">
              <div className="feature-item lumeno-mascot">
                <img
                  src={`${s3_url}/homepage/lumenko.webp`}
                  alt="Lumeno maskota"
                  className="lumeno-image"
                  loading="lazy"
                />
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <BsLaptop />
                </div>
                <p>100% online</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <BsClock />
                </div>
                <p>Fleksibilni termini</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <BsPeople />
                </div>
                <p>Iskusni nastavnici</p>
              </div>
              <div className="feature-item">
                <div className="feature-icon">
                  <BsGraphUp />
                </div>
                <p>Osigurani rezultati</p>
              </div>
            </div>

            <div className="d-lg-none">
              <Row className="mb-4">
                <Col xs={6}></Col>
                <Col xs={6} className="d-flex justify-content-start">
                  <div className="feature-item">
                    <div className="feature-icon">
                      <BsLaptop />
                    </div>
                    <p>100% online</p>
                  </div>
                </Col>
              </Row>

              <Row className="mb-4">
                <Col xs={6} className="d-flex flex-column gap-4">
                  <div className="feature-item">
                    <div className="feature-icon">
                      <BsClock />
                    </div>
                    <p>Fleksibilni termini</p>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon">
                      <BsPeople />
                    </div>
                    <p>Iskusni nastavnici</p>
                  </div>
                </Col>
                <Col
                  xs={6}
                  className="d-flex align-items-center justify-content-center"
                >
                  <div className="feature-item lumeno-mascot">
                    <img
                      src={`${s3_url}/homepage/lumenko.webp`}
                      alt="Lumeno maskota"
                      className="lumeno-image"
                      loading="lazy"
                    />
                  </div>
                </Col>
              </Row>

              <Row>
                <Col xs={6}></Col>
                <Col xs={6} className="d-flex justify-content-start">
                  <div className="feature-item">
                    <div className="feature-icon">
                      <BsGraphUp />
                    </div>
                    <p>Osigurani rezultati</p>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>

        <section className="teachers-section mt-5">
          <Container>
            <Row className="align-items-center">
              <Col
                lg={6}
                className="order-1 order-lg-1 mt-4 mt-lg-0 text-center"
              >
                <img
                  src={`${s3_url}/homepage/3.webp`}
                  alt="Nastava"
                  className="teachers-image circle"
                  loading="lazy"
                />
              </Col>
              <Col lg={6} className="order-2 order-lg-2">
                <div className="teachers-copy">
                  Naš tim čine iskusni, strpljivi i motivirani nastavnici koji
                  pristup prilagođavaju svakom učeniku. Bilo da se pripremaš za
                  maturu ili ti treba dodatna podrška u gradivu, naši profesori
                  prenose znanje jasno, stručno i s razumijevanjem. S nama učiš
                  u svom ritmu – uz podršku onih koji vjeruju u tvoj uspjeh.
                </div>
              </Col>
            </Row>
          </Container>
        </section>

        <section className="individual-section mt-5">
          <Container>
            <Row className="align-items-center">
              <Col
                lg={6}
                className="order-1 order-lg-2 text-center mt-4 mt-lg-0 position-relative"
              >
                <img
                  src={`${s3_url}/homepage/lumen-maturant.webp`}
                  alt="Lumen maturant"
                  className="individual-image"
                  loading="lazy"
                />
              </Col>
              <Col lg={6} className="order-2 order-lg-1">
                <h3 className="section-title text-center text-lg-start">
                  Tvoja motivacija, naš zadatak
                </h3>
                <p className="lead-text individual-copy">
                  Poduke su prilagođene zatečenom znanju kod polaznika s
                  naglaskom na pronalasku optimalnog pristupa kojim ćemo
                  polaznike motivirati, usmjeriti, poraditi na koncentraciji i
                  posljedično ostvariti željene rezultate kojima će se ponositi.
                </p>
                <p className="lead-text individual-copy mb-5">
                  Imaš pitanja? Slobodno nam se javi!
                </p>
                <div className="d-flex justify-content-center justify-content-lg-start mb-5">
                  <LumenButton to="/poduke/rezervacija" size="lg">
                    REZERVIRAJ TERMIN
                  </LumenButton>
                </div>
              </Col>
            </Row>
          </Container>

          <div className="bg-circle bg-circle-3" aria-hidden="true" />
        </section>

        <section className="gallery-section mt-5">
          <Container fluid className="px-0">
            <div className="gallery-row">
              {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                <div key={`first-${i}`} className="gallery-item">
                  <img
                    src={`${s3_url}/homepage/${i}.webp`}
                    alt={`Galerija ${i}`}
                    loading="lazy"
                  />
                </div>
              ))}
              {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
                <div key={`second-${i}`} className="gallery-item">
                  <img
                    src={`${s3_url}/homepage/${i}.webp`}
                    alt={`Galerija ${i}`}
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </Container>
        </section>
      </div>
      <NewFooter />
    </>
  );
};

export default NewHomePage;
